module.exports = require("@splunk/dashboard-visualizations/RadialGauge");